(function(window) { 'use strict';

    function Utilities() {}



    /*
     *  Browser Detection
     */

    Utilities.prototype.detect = {};

    Utilities.prototype.detect.all = function( notSupportedUserAgents, $elementToAppendClasses ) {
        this.detection = {
                browser: {
                    name: Utilities.prototype.detect.browser.getName(),
                    version: Utilities.prototype.detect.browser.getVersion(),
                    features: {
                        flash: Utilities.prototype.detect.browser.getFlashState(),
                        webcam: Utilities.prototype.detect.browser.getWebcamState()
                    },
                    support: Utilities.prototype.detect.browser.support(notSupportedUserAgents)
                },
                os: {
                    name: Utilities.prototype.detect.os.getName(),
                    version: Utilities.prototype.detect.os.getVersion(),
                    support: Utilities.prototype.detect.os.support(notSupportedUserAgents)
                },
                online: Utilities.prototype.detect.device.getOnlineState(),
                touch: Utilities.prototype.detect.device.getTouchState(),
                mobile: Utilities.prototype.detect.device.getMobileState(),
                type: ( Utilities.prototype.detect.device.getMobileState() ) ? 'mobile' : ( Utilities.prototype.detect.browser.getName() === 'iPad' || Utilities.prototype.detect.os.getName() === 'Android' ) ? 'tablet' : 'desktop',
                retina: Utilities.prototype.detect.device.getRetinaState()
            };

        if( $elementToAppendClasses ) {
            Utilities.prototype.detect.addClasses( $elementToAppendClasses );
        }

        return this.detection;
    };

    Utilities.prototype.detect.addClasses = function( $elementToAppendClasses ) {
        var classesToAdd = [];

        if( !this.detection.browser.support || !this.detection.os.support ) { classesToAdd.push('no-support'); } else { classesToAdd.push('has-support'); }
        if( !this.detection.retina) { classesToAdd.push('no-retina'); } else { classesToAdd.push('has-retina'); }
        if( !this.detection.touch) { classesToAdd.push('no-touch'); } else { classesToAdd.push('has-touch'); }

        classesToAdd.push(this.detection.type);

        $elementToAppendClasses.addClass(classesToAdd.join(' '));
    };

    Utilities.prototype.detect.searchString = function( data ) {
        for (var i = 0; i < data.length; i++) {
            var dataString = data[i].string,
                dataProp = data[i].prop;

            Utilities.prototype.detect.versionSearch = data[i].versionSearch || data[i].identity;

            if (dataString) {
                if (dataString.indexOf(data[i].subString) !== -1) {
                    return data[i].identity;
                }
            } else if (dataProp) {
                return data[i].identity;
            }
        }
    };

    Utilities.prototype.detect.getVersion = function() {
        var sVersionString = window.navigator.userAgent || window.navigator.appVersion,
            index = sVersionString.indexOf(Utilities.prototype.detect.versionSearch),
            version;

        if (index === -1) {
            return;
        }

        version = parseFloat(sVersionString.substring(index + Utilities.prototype.detect.versionSearch.length + 1));
        return isNaN(version) ? undefined : version;
    };

    Utilities.prototype.detect.device = {};

    Utilities.prototype.detect.device.getType = function() {
        return ( Utilities.prototype.detect.device.getMobileState() ) ? 'mobile' : ( Utilities.prototype.detect.browser.getName() === 'iPad' || Utilities.prototype.detect.os.getName() === 'Android' ) ? 'tablet' : 'desktop';
    };

    Utilities.prototype.detect.device.getRetinaState = function() {
        return ( window.devicePixelRatio > 1 ) ? true : false;
    };

    Utilities.prototype.detect.device.getTouchState = function() {
        return ('ontouchstart' in window) || (window.navigator.msMaxTouchPoints > 0);
    };

    Utilities.prototype.detect.device.getMobileState = function() {
        var dataString = window.navigator.userAgent || window.navigator.vendor || window.opera;
        return /(android|BB|bb\d+|meego).+mobile|avantgo|htc|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(dataString) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(dataString.substr(0, 4));
    };

    Utilities.prototype.detect.device.getOnlineState = function() {
        try {
            if (window.navigator.onLine) {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            return true;
        }
    };

    Utilities.prototype.detect.browser = {
        dataBrowser: [{
            string: window.navigator.userAgent,
            subString: 'Chrome',
            identity: 'Chrome'
        }, {
            string: window.navigator.userAgent,
            subString: 'iPad',
            identity: 'iPad'
        }, {
            string: window.navigator.userAgent,
            subString: 'iPhone',
            identity: 'iPhone/iPod'
        }, {
            string: window.navigator.userAgent,
            subString: 'OmniWeb',
            versionSearch: 'OmniWeb/',
            identity: 'OmniWeb'
        }, {
            string: window.navigator.vendor,
            subString: 'Apple',
            identity: 'Safari',
            versionSearch: 'Version'
        }, {
            string: window.navigator.userAgent,
            subString: 'Nexus',
            identity: 'Android',
            versionSearch: 'Android'
        }, {
            prop: window.opera,
            identity: 'Opera',
            versionSearch: 'Version'
        }, {
            string: window.navigator.vendor,
            subString: 'iCab',
            identity: 'iCab'
        }, {
            string: window.navigator.vendor,
            subString: 'KDE',
            identity: 'Konqueror'
        }, {
            string: window.navigator.userAgent,
            subString: 'Firefox',
            identity: 'Firefox'
        }, {
            string: window.navigator.vendor,
            subString: 'Camino',
            identity: 'Camino'
        }, {
            string: window.navigator.userAgent,
            subString: 'Netscape',
            identity: 'Netscape'
        }, {
            string: window.navigator.userAgent,
            subString: 'MSIE',
            identity: 'Explorer',
            versionSearch: 'MSIE'
        }, {
            string: window.navigator.userAgent,
            subString: 'NT',
            identity: 'Explorer',
            versionSearch: 'rv'
        }, {
            string: window.navigator.userAgent,
            subString: 'Gecko',
            identity: 'Mozilla',
            versionSearch: 'rv'
        }, {
            string: window.navigator.userAgent,
            subString: 'Mozilla',
            identity: 'Netscape',
            versionSearch: 'Mozilla'
        }],
        dataOS: [{
            string: window.navigator.platform,
            subString: 'Win',
            identity: 'Windows'
        }, {
            string: window.navigator.userAgent,
            subString: 'iPad',
            identity: 'OS',
            versionSearch: 'OS'
        }, {
            string: window.navigator.platform,
            subString: 'Mac',
            identity: 'Mac'
        }, {
            string: window.navigator.userAgent,
            subString: 'Android',
            identity: 'Android'
        }, {
            string: window.navigator.platform,
            subString: 'Linux',
            identity: 'Linux'
        }]
    };

    Utilities.prototype.detect.browser.getName = function() {
        return Utilities.prototype.detect.searchString(Utilities.prototype.detect.browser.dataBrowser);
    };

    Utilities.prototype.detect.browser.getVersion = function() {
        Utilities.prototype.detect.searchString(Utilities.prototype.detect.browser.dataBrowser);
        return Utilities.prototype.detect.getVersion();
    };

    Utilities.prototype.detect.browser.getFlashState = function() {
        try {
            var tmp = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
            if (tmp) {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            if (window.navigator.mimeTypes['application/x-shockwave-flash'] !== undefined && window.navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin !== null) {
                return true;
            } else {
                return false;
            }
        }
    };

    Utilities.prototype.detect.browser.getWebcamState = function() {

    };

    Utilities.prototype.detect.browser.support = function( aNotSupportedUserAgents ) {
        for (var key in aNotSupportedUserAgents) {
            if (Utilities.prototype.detect.browser.getName() === key) {
                if (Utilities.prototype.array.contains(aNotSupportedUserAgents[key], Utilities.prototype.detect.browser.getVersion())) {
                    return false;
                }
            }
        }
        return true;
    };

    Utilities.prototype.detect.os = {};

    Utilities.prototype.detect.os.getName = function() {
        return Utilities.prototype.detect.searchString(Utilities.prototype.detect.browser.dataOS);
    };

    Utilities.prototype.detect.os.getVersion = function() {
        Utilities.prototype.detect.searchString(Utilities.prototype.detect.browser.dataOS);
        return Utilities.prototype.detect.getVersion();
    };

    Utilities.prototype.detect.os.support = function( aNotSupportedOperationSystems ) {
        for (var key in aNotSupportedOperationSystems) {
            if (Utilities.prototype.detect.os.getName() === key) {
                if (Utilities.prototype.array.contains(aNotSupportedOperationSystems[key], Utilities.prototype.detect.os.getVersion())) {
                    return false;
                }
            }
        }
        return true;
    };



    /*
     *  Arrays
     */

    Utilities.prototype.array = {};

    Utilities.prototype.array.contains = function(aArray, sValue, type) {
        for (var i = 0; i < aArray.length; i++) {
            if( type === 'indexof' ) {
                if( sValue.indexOf(aArray[i]) > -1 ) {
                    return true;
                }
            } else if( aArray[i] === sValue) {
                return true;
            }
        }

        return false;
    };

    Utilities.prototype.array.containsBlacklist = function(aArray, sValue) {
        for (var i = 0; i < aArray.length; i++) {

            var position = sValue.indexOf(aArray[i]);
            if( position > -1 ) {
                var nextChar = sValue.charAt(position + aArray[i].length) || '';
                var prevChar = Math.max(sValue.charAt(position - 1), 0) || '';
                var validPrevchar = prevChar.search(/^[a-z]+$/i);
                var validNextChar = nextChar.search(/^[a-z]+$/i);

                if( ( sValue.length === aArray[i].length ) || (prevChar && validPrevchar === -1 || nextChar && validNextChar === -1) ) {
                    return true;
                }
            }
        }

        return false;
    };

    Utilities.prototype.array.shuffle = function(aArray) {

        var currentIndex = aArray.length, temporaryValue, randomIndex;

        while (0 !== currentIndex) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            temporaryValue = aArray[currentIndex];
            aArray[currentIndex] = aArray[randomIndex];
            aArray[randomIndex] = temporaryValue;
        }

        return aArray;

    };



    /*
     *  Base64
     */

    Utilities.prototype.base64 = {};

    Utilities.prototype.base64._keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

    Utilities.prototype.base64.encode = function(input) {
        var output = '';
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;

        input = Utilities.prototype.base64._utf8_encode(input);

        while (i < input.length) {

            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output + Utilities.prototype.base64._keyStr.charAt(enc1) + Utilities.prototype.base64._keyStr.charAt(enc2) + Utilities.prototype.base64._keyStr.charAt(enc3) + Utilities.prototype.base64._keyStr.charAt(enc4);

        }

        return output;
    };

    Utilities.prototype.base64.decode = function(input) {
        var output = '';
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

        while (i < input.length) {

            enc1 = Utilities.prototype.base64._keyStr.indexOf(input.charAt(i++));
            enc2 = Utilities.prototype.base64._keyStr.indexOf(input.charAt(i++));
            enc3 = Utilities.prototype.base64._keyStr.indexOf(input.charAt(i++));
            enc4 = Utilities.prototype.base64._keyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }

        }

        output = Utilities.prototype.base64._utf8_decode(output);

        return output;

    };

    Utilities.prototype.base64._utf8_encode = function(string) {
        string = string.replace(/\r\n/g, '\n');
        var utftext = '';

        for (var n = 0; n < string.length; n++) {

            var c = string.charCodeAt(n);

            if (c < 128) {
                utftext += String.fromCharCode(c);
            }
            else if ((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            }
            else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }

        }

        return utftext;
    };

    Utilities.prototype.base64._utf8_decode = function(utftext) {
        var string = '';
        var i = 0;
        var c = 0;
        var c1 = 0;
        var c2 = 0;
        var c3 = 0;

        while (i < utftext.length) {

            c = utftext.charCodeAt(i);

            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            }
            else if ((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i + 1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            }
            else {
                c2 = utftext.charCodeAt(i + 1);
                c3 = utftext.charCodeAt(i + 2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }

        }

        return string;
    };



    /*
     *  URLs
     */

    Utilities.prototype.urls = {};

    Utilities.prototype.urls.dataURItoBlob = function( dataURI ) { // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(dataURI.split(',')[1]);
        } else {
            byteString = unescape(dataURI.split(',')[1]);
        }
        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ia], {type:mimeString});
    };



    /*
     *  Popups
     */

    Utilities.prototype.popups = {};

    Utilities.prototype.popups.openCenteredPopup = function( url, title, w, h, setFocus ) {

        var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var left = ((width / 2) - (w / 2)) + dualScreenLeft;
        var top = ((height / 2) - (h / 2)) + dualScreenTop;
        var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if( window.focus && setFocus ) {
            newWindow.focus();
        }

        return newWindow;
    };



    /*
     *  Canvas
     */

    Utilities.prototype.canvas = {};

    Utilities.prototype.canvas.scaleImageToImproveQuality = function( image, width, height, scaleFactor ) {
        var tempCanvas = document.createElement('canvas');
        var tempContext = tempCanvas.getContext('2d');
        tempCanvas.width = width / scaleFactor;
        tempCanvas.height = height / scaleFactor;
        tempContext.drawImage(image, 0, 0, tempCanvas.width, tempCanvas.height);
        return tempCanvas;
    };



    /*
     *  Geolocation
     */

    Utilities.prototype.geolocation = {};

    Utilities.prototype.geolocation.getGpsString = function( latDirection, latPosition, lonDirection, lonPosition ) {
        return latPosition[0] + '°' + latPosition[1] + '\'' + latPosition[2] + '\'\'' + ' ' + latDirection + ' ' + lonPosition[0] + '°' + lonPosition[1] + '\'' + lonPosition[2] + '\'\'' + ' ' + lonDirection;
    };

    Utilities.prototype.geolocation.convertGpsStringToLatLon = function( input ) {

        if( input.indexOf( 'N' ) == -1 && input.indexOf( 'S' ) == -1 && input.indexOf( 'W' ) == -1 && input.indexOf( 'E' ) == -1 ) {
            return input.split(',');
        }

        var parts = input.split(/[°'"]+/).join(' ').split(/[^\w\S]+/);
        var directions = [];
        var coords = [];
        var dd = 0;
        var pow = 0;

        for( var i in parts ) {

            // we end on a direction
            if( isNaN( parts[i] ) ) {

                var _float = parseFloat( parts[i] );

                var direction = parts[i];

                if( !isNaN(_float ) ) {
                    dd += ( _float / Math.pow( 60, pow++ ) );
                    direction = parts[i].replace( _float, '' );
                }

                direction = direction[0];

                if( direction == 'S' || direction == 'W' ) {
                    dd *= -1;
                }

                directions[ directions.length ] = direction;

                coords[ coords.length ] = dd;
                dd = pow = 0;

            } else {

                dd += ( parseFloat(parts[i]) / Math.pow( 60, pow++ ) );

            }

        }

        if( directions[0] == 'W' || directions[0] == 'E' ) {
            var tmp = coords[0];
            coords[0] = coords[1];
            coords[1] = tmp;
        }

        return coords;

    };


    Utilities.prototype.geolocation.calculateDistance = function(lat1, lon1, lat2, lon2) {
        var R = 6371; // km
        var dLat = Utilities.prototype.toRad(lat2 - lat1);
        var dLon = Utilities.prototype.toRad(lon2 - lon1);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(Utilities.prototype.toRad(lat1)) * Math.cos(Utilities.prototype.toRad(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return d;
    };

    Utilities.prototype.geolocation.toRad = function( number ) {
        return number * Math.PI / 180;
    };

    window.Utilities = Utilities;

})(window);